import type { GetProjects } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";
import { useSearch } from "@tanstack/react-router";

import apiClient from "@/lib/api/client";

export function useResolveProjects() {
  const { "project-id": projectId } = useSearch({
    from: "/_auth/_app-shell/users/create",
  });
  const url = projectId
    ? `/users/resolve-projects?projectId=${projectId}`
    : `/users/resolve-projects`;

  return useQuery({
    queryFn: () => apiClient.url(url).get().json<GetProjects>(),
    queryKey: ["user-resolve-projects", projectId],
  });
}
